import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 26 26",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.75 9.896a.75.75 0 0 1 .75-.75h6.54a.75.75 0 0 1 0 1.5H8.5a.75.75 0 0 1-.75-.75m0 3.568a.75.75 0 0 1 .75-.75h3.568a.75.75 0 1 1 0 1.5H8.5a.75.75 0 0 1-.75-.75",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.614 4.622a.75.75 0 0 1 .75-.75h4.318a.75.75 0 0 1 0 1.5H5.114V22.25h15.772v-1.953a.75.75 0 0 1 1.5 0V23a.75.75 0 0 1-.75.75H4.364a.75.75 0 0 1-.75-.75zm12.954 0a.75.75 0 0 1 .75-.75h4.318a.75.75 0 0 1 .75.75v1.891a.75.75 0 0 1-1.5 0V5.372h-3.568a.75.75 0 0 1-.75-.75",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.932 4.622a2.37 2.37 0 0 1 2.371-2.372h5.393a2.372 2.372 0 0 1 0 4.743h-5.393a2.37 2.37 0 0 1-2.371-2.371m2.371-.872a.872.872 0 1 0 0 1.743h5.393a.872.872 0 0 0 0-1.743zm7.889 14.15 4.596-4.597a1.5 1.5 0 1 0-2.122-2.121l-4.596 4.596-.353 2.475zm5.656-7.779a3 3 0 0 0-4.242 0l-4.773 4.773a.75.75 0 0 0-.212.425l-.484 3.382a1 1 0 0 0 1.132 1.131l3.382-.483a.75.75 0 0 0 .424-.212l4.773-4.773a3 3 0 0 0 0-4.243",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=FormsIcon26.js.map